const DOCUMENT = 'MESSAGES_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),
};

export default actions;
